import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const tabTheme: Pick<Components<Theme>, 'MuiTabs' | 'MuiTab'> = {
  MuiTabs: {
    styleOverrides: {
      root: ({ theme }) => ({
        variants: [
          {
            props: { orientation: 'horizontal' },
            style: {
              borderBottom: '1px solid',
              borderColor: (theme.vars || theme).palette.divider,
            },
          },
          {
            props: { orientation: 'vertical' },
            style: {
              borderRight: '1px solid',
              borderColor: (theme.vars || theme).palette.divider,
            },
          },
        ],
      }),
      flexContainerVertical: {
        alignItems: 'baseline',
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        minHeight: '42px', // diminish min-height to avoid tab with icon to default to 72px
      },
    },
  },
};
